export const alignmentDragIcon = {
  'Small1.5': 'top: 0px',
  'Small1.6': 'top: 1px',
  'Small1.7': 'top: 1px',
  'Small1.8': 'top: 2px',
  'Small1.9': 'top: 3px',
  'Medium1.5': 'top: 1px',
  'Medium1.6': 'top: 2px',
  'Medium1.7': 'top: 2px',
  'Medium1.8': 'top: 3px',
  'Medium1.9': 'top: 4px',
  'Large1.5': 'top: 2px',
  'Large1.6': 'top: 2px',
  'Large1.7': 'top: 3px',
  'Large1.8': 'top: 4px',
  'Large1.9': 'top: 5px',
  'Extra Large1.5': 'top: 3px',
  'Extra Large1.6': 'top: 3px',
  'Extra Large1.7': 'top: 4px',
  'Extra Large1.8': 'top: 5px',
  'Extra Large1.9': 'top: 6px'
}

export const alignmentList = {
  'Small1.5': 'top: 7px',
  'Small1.6': 'top: 8px',
  'Small1.7': 'top: 8px',
  'Small1.8': 'top: 9px',
  'Small1.9': 'top: 10px',
  'Medium1.5': 'top: 8px',
  'Medium1.6': 'top: 9px',
  'Medium1.7': 'top: 9.5px',
  'Medium1.8': 'top: 10.5px',
  'Medium1.9': 'top: 11px',
  'Large1.5': 'top: 9px',
  'Large1.6': 'top: 9.5px',
  'Large1.7': 'top: 10px',
  'Large1.8': 'top: 11px',
  'Large1.9': 'top: 12px',
  'Extra Large1.5': 'top: 10px',
  'Extra Large1.6': 'top: 10px',
  'Extra Large1.7': 'top: 11px',
  'Extra Large1.8': 'top: 12px',
  'Extra Large1.9': 'top: 13px'
}

export const alignmentTask = {
  'Small1.5': 'margin-top: 2px',
  'Small1.6': 'margin-top: 3px',
  'Small1.7': 'margin-top: 3px',
  'Small1.8': 'margin-top: 4px',
  'Small1.9': 'margin-top: 5px',
  'Medium1.5': 'margin-top: 3px',
  'Medium1.6': 'margin-top: 4px',
  'Medium1.7': 'margin-top: 4px',
  'Medium1.8': 'margin-top: 5px',
  'Medium1.9': 'margin-top: 5px',
  'Large1.5': 'margin-top: 4px',
  'Large1.6': 'margin-top: 5px',
  'Large1.7': 'margin-top: 5px',
  'Large1.8': 'margin-top: 6px',
  'Large1.9': 'margin-top: 7px',
  'Extra Large1.5': 'margin-top: 4px',
  'Extra Large1.6': 'margin-top: 5px',
  'Extra Large1.7': 'margin-top: 6px',
  'Extra Large1.8': 'margin-top: 7px',
  'Extra Large1.9': 'margin-top: 8px'
}
